import { render, staticRenderFns } from "./ModalUnCobro.vue?vue&type=template&id=65d7644d&scoped=true"
import script from "./ModalUnCobro.vue?vue&type=script&lang=js"
export * from "./ModalUnCobro.vue?vue&type=script&lang=js"
import style0 from "./ModalUnCobro.vue?vue&type=style&index=0&id=65d7644d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7644d",
  null
  
)

export default component.exports